<template>
    <div class="delivery-maintain-create">
        <el-form label-width="160px" size="mini">
            <el-form-item label="维护名称">
                <el-input v-model="maintain.name" placeholder="请输入维护名称"/>
            </el-form-item>
            <el-form-item label="设备周期计费上限(元)">
                <el-input size="mini" v-model="maintain.maxFee"
                          @change="maintain.maxFee=materielExtraCostChange(maintain.maxFee)"></el-input>
            </el-form-item>
            <el-form-item label="设备计费重置周期(天)">
                <el-input size="mini" v-model.number="maintain.resetPeriod"></el-input>
            </el-form-item>
            <el-form-item label="工作时间">
                <el-time-select
                        placeholder="起始时间"
                        v-model="startTime"
                        :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '24:00'
                        }">
                </el-time-select>
                <el-time-select
                        placeholder="结束时间"
                        v-model="endTime"
                        :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '24:00',
                          minTime: startTime
                        }">
                </el-time-select>
            </el-form-item>

        </el-form>

    </div>

</template>

<script>
    import {maintainSetDeviceParamTmplCreate} from '@/api/delivery/device/maintainSet'
    export default {
        name: '',
        props: {
            close: {
                type: Function,
                default: null,
            }
        },
        components: {},
        mounted: function () {
        },
        data: function () {
            return {
                startTime: '',
                endTime: '',
                maintain: {
                    name: '',
                    maxFee: 0,
                    resetPeriod: 0,
                    startHour: 0,
                    startMinute: 0,
                    endHour: 0,
                    endMinute: 0,
                }
            }
        },
        methods: {
            materielExtraCostChange(item) {
                // 防止删除为空
                if (!item) {
                    item = '0.00'
                }
                // 一些错误金额输入的判断
                if (item.toString().indexOf('.') > 0 && Number(item.toString().split('.')[1].length) < 1) {
                    item = item.toString().split('.')[0]
                }
                // 一些错误金额输入的判断
                if (!item || item === '-' || item === '-0') {
                    item = '0.00'
                }

                return parseFloat(item).toFixed(2)
            },

            createDeviceParamTmpl() {
                if (this.maintain.name.length === 0) {
                    this.$message.warning('请输入饮品名称')
                    return
                }

                if (this.startTime.length === 0) {
                    this.$message.warning('请选取开始工作时间')
                    return
                }

                if (this.endTime.length === 0) {
                    this.$message.warning('请选取结束工作时间')
                    return
                }

                let start = this.startTime.split(`:`)
                let end = this.endTime.split(`:`)

                this.maintain.startHour = parseInt(start[0])
                this.maintain.startMinute = parseInt(start[1])
                this.maintain.endHour = parseInt(end[0])
                this.maintain.endMinute = parseInt(end[1])
                this.maintain.resetPeriod = this.maintain.resetPeriod * 24 * 3600

                this.maintain.maxFee = parseFloat(this.maintain.maxFee) * 100
                maintainSetDeviceParamTmplCreate(this.maintain).then(() => {
                    this.$message.success('添加成功')
                    if (this.close) {
                        this.close()
                    }
                })
            }
        },
    }
</script>

<style lang="scss">
    .delivery-maintain-create {
        padding: 0 $padding;

        .logo-upload {
            height: 20rem;
        }
    }
</style>
